import { Environment } from './environment.model';

export const environment: Environment = {
  production: false,
  name: 'dev',
  apiUrl: 'https://dev.api.stargatehospital-vt.com',
  // Firebase web app "sg-hospital" in project sg-hospital-dev.
  firebaseConfig: {
    apiKey: 'AIzaSyCqTB7YihVh6pqC7yg9LmKA6p3mBFQVZrA',
    authDomain: 'sg-hospital-dev.firebaseapp.com',
    projectId: 'sg-hospital-dev',
    appId: '1:173081611192:web:41a1bced7b5498934add4d',
    messagingSenderId: '173081611192',
    storageBucket: 'sg-hospital-dev.firebasestorage.app',
  },
  inactivity: {
    warningAfterMs: 840 * 1000,
    logoutAfterMs: 60 * 1000,
  },
};
